import { styled } from '@abyss/web/tools/styled';
import { Flex } from '@abyss/web/ui/Flex';
export const BtnWrapper = styled(Flex, {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  gap: '10px',
  alignSelf: 'stretch',
  backgroundColor: '$white',
  padding: '20px 0px',
  marginTop: '12px',
  variants: {
    mobileScreen: {
      true: {
        boxShadow: '0px -5px 5px -5px rgba(0, 0, 0, 0.2)',
        position: 'sticky',
        bottom: 0,
      },
      false: {
        position: 'sticky',
        bottom: 0,
      },
    },
  },
});
